import { left } from 'fp-ts/Either';
import { httpClientFunction } from 'domain/types';
import { UpdateDashboardNameClient } from 'use-case/dashboard/update/updateDashboardClient';

import { callbackParseDashboardResponse } from 'adapter/out/client/dashboard/callbackParseDashboardResponse';
import { UpdateDashboardNameCriteria } from 'use-case/dashboard/update/updateDashboardCriteria/updateDashboardNameCriteria';

export default (httpClient: httpClientFunction, baseUrl: string): UpdateDashboardNameClient => (criteria: UpdateDashboardNameCriteria) =>
    httpClient(`${baseUrl}/dashboards/dashboards/${criteria.id}`, {
        method: 'PATCH',
        body: JSON.stringify(asDashboardJson(criteria)),
        headers: { 'Content-Type': 'application/json' },
    })
        .then((response) => callbackParseDashboardResponse(response))
        .catch(() => left({ error: new Error(), status: 503 }));

export const asDashboardJson = (criteria: UpdateDashboardNameCriteria): DashboardUpdateNameJsonRequest => ({
    name: criteria.name,
    description: criteria.description,
});

export type DashboardUpdateNameJsonRequest = {
    name: string;
    description: string;
};
